import { Utils } from ".";

let nextPage = async (next, data = {}) => {
  return await fetch(`${next}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      // Authorization: `Bearer ${Utils.Auth.getSessionToken()}`,
    },
    body: JSON.stringify(data),
  })
    .then((response) => {
      return response.json();
    })
    .then((data) => data);
};

let previousPage = async (previous, data = {}) => {
  return await fetch(`${previous}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      // Authorization: `Bearer ${Utils.Auth.getSessionToken()}`,
    },
    body: JSON.stringify(data),
  })
    .then((response) => {
      return response.json();
    })
    .then((data) => data);
};



// Versions GET
let nextPageGet = async (next) => {
  return await fetch(`${next}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      // Authorization: `Bearer ${Utils.Auth.getSessionToken()}`,
    },
  })
    .then((response) => response.json())
    .then((data) => data);
};

let previousPageGet = async (previous) => {
  return await fetch(`${previous}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      // Authorization: `Bearer ${Utils.Auth.getSessionToken()}`,
    },
  })
    .then((response) => response.json())
    .then((data) => data);
};

export { nextPage, previousPage, nextPageGet, previousPageGet };